import moment from "moment-timezone";

const formatDate = (isoString) => {
  if (!isoString) return ""; // handle null/undefined/empty
  const date = new Date(isoString);
  if (isNaN(date.getTime())) return ""; // handle invalid dates
  return new Intl.DateTimeFormat("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);
};

const formatDateByLocale = (date, locale) => {
  const formatter = new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));

  const isMonthFirst = locale?.startsWith("en");

  const datePart = isMonthFirst ? `${map.month}/${map.day}/${map.year}` : `${map.day}/${map.month}/${map.year}`;

  const timePart = `${map.hour}:${map.minute}:${map.second}`;

  return `${datePart} ${timePart}`;
};

const getDateWithOffset = (date, offsetMinutes) => {
  // Remove browser's local timezone offset
  const localOffsetMs = date.getTimezoneOffset() * 60 * 1000;

  // Apply target timezone offset
  const targetOffsetMs = offsetMinutes * 60 * 1000;

  return new Date(date.getTime() + localOffsetMs + targetOffsetMs);
};

const formatUtcWithOffset = (utcIsoString, timezoneOffsetHours = 0, /** @type {string | null} */ timezone = null) => {
  if (!utcIsoString) {
    return "";
  }
  const locale = localStorage.getItem("locale") || "tr";
  const date = new Date(utcIsoString);
  const timezoneName = typeof timezone === "string" ? timezone.trim() : "";

  if (timezoneName && moment.tz.zone(timezoneName)) {
    const timezoneMoment = moment.utc(utcIsoString).tz(timezoneName);

    if (timezoneMoment.isValid()) {
      const timezoneOffsetMinutes = timezoneMoment.utcOffset();
      return formatDateByLocale(getDateWithOffset(date, timezoneOffsetMinutes), locale);
    }
  }

  const deviceDate = getDateWithOffset(date, timezoneOffsetHours * 60);

  return formatDateByLocale(deviceDate, locale);
};

export { formatDate, formatUtcWithOffset };
